export default "You are locked in a prison cell. You have to solve all the riddles and puzzles to figure out how to escape.";